export const partnerNavItems = [
    {
        label: 'Produtos e serviços',
        to: '/produtos',
        isActive: (path) =>
            path === '/' ||
            path.startsWith('/produtos') ||
            path.startsWith('/produto-detalhes') ||
            path.startsWith('/servico-novo'),
        children: [
            { label: 'Produtos', to: '/produtos' },
            { label: 'Serviços', to: '/servico-novo' },
        ],
    },
    {
        label: 'Meus pedidos',
        to: '/pedidos',
        isActive: (path) => path.startsWith('/pedido'),
    },
    {
        label: 'Orçamentos',
        to: '/orcamentos',
        isActive: (path) => path.startsWith('/orcamento'),
    },
    {
        label: 'Meu catálogo',
        to: '/meu-catalogo',
        requiresCatalog: true,
        isActive: (path) => path.startsWith('/meu-catalogo'),
    },
];

export function isCatalogEnabled(user) {
    const flag = user?.has_catalog;
    return flag === true || flag === 1 || flag === '1';
}

export function getPartnerNav(user) {
    return partnerNavItems.filter(
        (item) => !item.requiresCatalog || isCatalogEnabled(user)
    );
}

export function getDrawerLinks(user) {
    const links = [
        { title: 'Produtos', to: '/produtos' },
        { title: 'Serviços', to: '/servico-novo' },
        { title: 'Meus pedidos', to: '/pedidos' },
        { title: 'Orçamentos', to: '/orcamentos' },
    ];

    if (isCatalogEnabled(user)) {
        links.push({ title: 'Meu catálogo', to: '/meu-catalogo' });
    }

    links.push({ title: 'Meu perfil', to: '/meu-perfil' });

    return links;
}

export function getGreetingName(user, userName) {
    const source = user?.main_manager || userName || user?.complete_name || '';
    return source.trim().split(/\s+/)[0] || 'parceiro';
}

export function getGreetingInitial(name) {
    return (name || 'P').charAt(0).toUpperCase();
}
